// import moment from "moment/moment";
// import { SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerConsolidado(obj) {
    try {
        let response = { error: true };
        const { error, mensaje, nombreFile } = await fetch(
            "https://gestiondeflota.boltrack.net/reportes/RP503BodyV01.rep",
            {
                headers: getHeaders(false),
                method: "POST",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (error === true) {
            alert(mensaje);
        }
        if (error === false) {
            response.error = false;
            response.data = nombreFile;
        }
        return response;
    } catch (err) {
        console.log("obtenerListaArea err");
        console.log(err);
        return { error: true, mensaje: err };
    }
}
